export const GOOGLE_TRACKING_ID = "UA-219534087-1";
